import { useState } from 'react';

import AlertExample from './AlertExample.tsx';
import AdvancedAlertExamples from './AdvancedAlertExamples.tsx';
import PracticalExamples from './PracticalExamples.tsx';

const AlertSample = () => {
    const [activeTab, setActiveTab] = useState<
        'basic' | 'advanced' | 'practical'
    >('basic');

    const renderContent = () => {
        switch (activeTab) {
            case 'basic':
                return <AlertExample />;
            case 'advanced':
                return <AdvancedAlertExamples />;
            case 'practical':
                return <PracticalExamples />;
            default:
                return <AlertExample />;
        }
    };

    return (
        <>
            <nav>
                <button
                    onClick={() => setActiveTab('basic')}
                    style={{
                        padding: '10px 20px',
                        marginRight: '10px',
                        backgroundColor:
                            activeTab === 'basic' ? '#007bff' : '#f8f9fa',
                        color: activeTab === 'basic' ? 'white' : 'black',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    기본 사용법
                </button>
                <button
                    onClick={() => setActiveTab('advanced')}
                    style={{
                        padding: '10px 20px',
                        marginRight: '10px',
                        backgroundColor:
                            activeTab === 'advanced' ? '#007bff' : '#f8f9fa',
                        color: activeTab === 'advanced' ? 'white' : 'black',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    고급 기능
                </button>
                <button
                    onClick={() => setActiveTab('practical')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor:
                            activeTab === 'practical' ? '#007bff' : '#f8f9fa',
                        color: activeTab === 'practical' ? 'white' : 'black',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    실용적인 예시
                </button>
            </nav>

            {renderContent()}
        </>
    );
};

export default AlertSample;
